import request from '@/libs/request'

// 平台用户列表
export function agentUserList (data) {
  return request({
    url: `agent/list`,
    method: 'get',
    params: data
  })
}


// 启用禁用用户
export function edits (data) {
  return request({
    url: `agent/list`,
    method: 'post',
    data
  })
}

export function agentUserInfo (id) {
  return request({
    url: `agent/info/${id}`,
    method: 'get'
  })
}

//
// // 启用禁用用户
// export function changeStatus (id) {
//   return request({
//     url: `admin/changeStatus/${id}`,
//     method: 'post'
//   })
// }

// 删除平台用户
export function delUser (id) {
  return request({
    url: `agent/list/${id}`,
    method: 'delete'
  })
}
export function regionInfo () {
  return request({
    url: `agent/regions`,
    method: 'get'
  })
}
//================
export function agentAreaList (data) {
  return request({
    url: `agentArea/list`,
    method: 'get',
    params: data
  })
}
export function addArea (data) {
  return request({
    url: `agentArea/list`,
    method: 'post',
    data
  })
}
export function agentInfo (id) {
  return request({
    url: `agentArea/info/${id}`,
    method: 'get'
  })
}
export function delArea (id) {
  return request({
    url: `agentArea/list/${id}`,
    method: 'delete'
  })
}



